import http from "@/common/http-common";
import store from "@/store";

class SitePrimaryFunctionService {
  async loadAll() {
    return http().get("/api/v1/site_primary_functions.json").then(function(resp) {
      console.log("Inside SitePrimaryFunctionService.loadAll, resp.data ==> ", resp.data);
      store.commit("updateSitePrimaryFunctions", resp.data);
    })

  }
}

export default new SitePrimaryFunctionService();